import styled from "styled-components";

export const StyledGraphWrapper = styled.div`
    position: relative;
    max-width: 800px;
    width: 100%;
    min-height: 150px;
`;

export const StyledGraph = styled.div`
    padding: 1em 0;
    }
`;
